export enum TRANSFORMATIONS {
    SHARPEN = 'sharpen',
    IMPROVE = 'improve',
    AUTO_FORMAT = 'autoFormat',
    AUTO_QUALITY = 'autoQuality',
    AUTO_SIZE = 'autoSize',
    RADIUS = 'radius',
    RESIZE = 'resize',
    VIDEO_THUMBNAIL = 'videoThumbnail',
    NAMED_TRASNFORMATION = 'namedTransformation',
    TEXT_OVERLAY = 'textOverlay'
}

export interface Transformation {
    name: TRANSFORMATIONS,
    params?: unknown
}
